
<div class="participantes ibox-content mb-4">
  <form [formGroup]="form" (ngSubmit)="salvar()" (keydown.enter)="$event.preventDefault()">
    <div class="d-flex justify-content-between mb-2">
      <b>Participantes vinculados:</b>
      <button class="btn btn-primary" (click)="openModal('participant')" type="button">Novo participante</button>
    </div>
    <div class="system-table">
      <div class="system-table-conteiner">
        <table >
          <thead>
            <tr>
              <th class="title">Nome</th>
              <th class="">Órgão</th>
              <th class="">Contato</th>
              <th class=""></th>
            </tr>
          </thead>
          <tbody formArrayName="participant">
            <ng-container *ngFor="let item of participantArray.controls;let i = index;" [formGroupName]="i">
              <tr   *ngIf="data?.participant[i] as currentItem">
                <td >{{currentItem?.name ?? currentItem?.label }}</td>
                <td >{{currentItem?.agency_name}}</td>
                <td >{{currentItem?.contact}}</td>
                <td >
                  <div class="btn-icon justify-content-end">
                    <button class="btn btn-font-icon ms-1" type="button" (click)="excluir(currentItem, 'participant')"
                      alt="Deletar" title="Deletar">
                      delete
                    </button>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
    <hr>
    <div class="d-flex justify-content-between mb-2">
      <b>Participantes não vinculados:</b>
      <button class="btn btn-primary" (click)="openModal('participantForeign')" type="button">Novo participante</button>
    </div>
    <div class="system-table">
      <div class="system-table-conteiner">
        <table >
          <thead>
            <tr>
              <th class="title">Nome</th>
              <th class="">Cargo</th>
              <th class="">Órgão</th>
              <th class="">Telefone</th>
              <th class="">Email</th>
              <th class=""></th>
            </tr>
          </thead>
          <tbody formArrayName="participantForeign">
            <ng-container *ngFor="let item of participantForeignArray.controls;let i = index;" [formGroupName]="i">
              <tr  *ngIf="data?.participantForeign[i] as currentItem">
                <td >{{currentItem?.name}}</td>
                <td >{{currentItem?.role_txt}}</td>
                <td >{{currentItem?.agency_name}}</td>
                <td >{{currentItem?.fone}}</td>
                <td >{{currentItem?.email}}</td>
                <td >
                  <div class="btn-icon justify-content-end mw-none" >
                    <button class="btn btn-font-icon ms-2" type="button" (click)="excluir(currentItem, 'participantForeign')"
                      alt="Deletar" title="Deletar">
                      delete
                    </button>
                    <button class="btn btn-font-icon ms-2" type="button" (click)="openModal('participantForeign',currentItem)"
                      alt="Editar" title="Editar">
                      edit_square
                    </button>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
    <div class="hr-line-dashed">
      <div class="form-group row d-flex justify-content-end text-dark">
        <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
          <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
          <button class="btn btn-primary m-r-xs" type="button" (click)="confirmSendMail()">
            <span class="font-icon  m-r-xs"> share </span>
            Enviar convite da reunião
          </button>
          <button class="btn btn-primary " type="submit">Salvar</button>
        </div>
      </div>
    </div>
  </form>
</div>

<ng-template #modal>
  <app-participantes-edit [id]="id" [data]="currentData" [type]="currentType" 
    (closeModal)="closeModal()" (excluir)="excluir($event, currentType)" 
    (salvar)="incluir($event, currentType)">
  </app-participantes-edit>
</ng-template>
<app-loading [loader]="isLoading"></app-loading>